import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Autocomplete
} from '@mui/material';
import { Box } from '@mui/system';
import { pdfjs } from 'react-pdf';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';
// table component
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { useLocation } from 'react-router-dom';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useDispatch } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CloseIcon from '@mui/icons-material/Close';

import partnerService from '../../../services/partnerService';
import AgreementService from '../../../services/AgreementService';
import { UserMoreMenu } from '../../../../components/_dashboard/user';
import useAgreementSelector from '../../../../store/Slice/Agreement/AgreementSelector';
import { setApiError } from '../../../../store/Slice/Error/ErrorSlice';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

const { StateList, CityList } = partnerService;
const { SaveBranchInfo, DeleteBranchInfo, CheckBranch, AgreementBankBranchList } = AgreementService;

export default function AggrementAddStep2({
  handlePrev,
  setActiveStep,
  reviewData,
  setReviewData
}) {
  const [branchEdit, setBranchEdit] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [validationMsg1, setValidationMsg1] = useState('');
  const [stateListData, setStateListData] = useState([]);
  const [cityListData, setCityListData] = useState([]);
  const [cityListData2, setCityListData2] = useState([]);
  const [branchIndexValue, setBranchIndexValue] = useState(null);
  const [itemBranchIndexValue, setitemBranchIndexValue] = useState({});
  const [agreementId1, setAgreementId1] = useState('');
  const [bankId1, setBankId1] = useState('');
  const [agreementBankId, setAgreementBankId] = useState('');
  const [companyId1, setCompanyId1] = useState('');
  const [userId1, setUserId1] = useState('');
  const [branchItem, setBranchItem] = useState({});
  const [branchIndex1, setBranchIndex1] = useState(null);
  const [addBranchObj, setAddBranchObj] = useState({
    branchName: '',
    branchId: null,
    branchAddress: '',
    bankContactPerson: {
      bankId: null,
      contactId: null,
      contactFirstName: '',
      contactLastName: '',
      contactPersonName: ''
    },
    contactPerson: '',
    branchStateId: '',
    stateName: '',
    branchCityId: '',
    cityName: '',
    branchCode: '',
    gstNumber: ''
  });
  const [addBranchObjEdit, setAddBranchObjEdit] = useState({
    branchName: '',
    branchId: null,
    branchAddress: '',
    bankContactPerson: {
      bankId: null,
      contactId: null,
      contactFirstName: '',
      contactLastName: '',
      contactPersonName: ''
    },
    contactPerson: '',
    branchStateId: '',
    stateName: '',
    branchCityId: '',
    cityName: '',
    branchCode: '',
    gstNumber: ''
  });
  const [branchList, setBranchList] = useState([]);

  const location = useLocation();
  const dispatch = useDispatch();
  const { AgreementEdit } = useAgreementSelector();
  const { LoginData } = useLoginSelector();

  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleAddBranch = async (e) => {
    if (addBranchObj.branchName === '') {
      setOpen1(true);
      setValidationMsg1('Please select branch name');
      return;
    }
    if (addBranchObj.branchAddress === '') {
      setOpen1(true);
      setValidationMsg1('Please select branch address');
      return;
    }
    if (addBranchObj.contactPerson === '') {
      setOpen1(true);
      setValidationMsg1('Please add contact person');
      return;
    }
    if (addBranchObj.stateName === '') {
      setOpen1(true);
      setValidationMsg1('Please select state name');
      return;
    }
    if (addBranchObj.cityName === '') {
      setOpen1(true);
      setValidationMsg1('Please select city name');
      return;
    }
    if (addBranchObj.branchCode === '') {
      setOpen1(true);
      setValidationMsg1('Please add login code');
      return;
    }

    const CheckBranchApi = await CheckBranch(
      {
        bankId: agreementBankId !== '' ? agreementBankId : null,
        branchName: addBranchObj.branchName
      },
      LoginData?.jwt
    );

    if (CheckBranchApi.data.isBranchExist === false) {
      const filterBranchName = branchList.filter(
        (item, index) =>
          item.branchName.toLowerCase().trim() === addBranchObj.branchName.toLowerCase().trim()
      );

      if (filterBranchName.length > 0) {
        setOpen1(true);
        setValidationMsg1('Branch already exists - Please try entering with another branch');
      } else {
        const newArray = branchList;
        newArray.push(addBranchObj);
        setBranchList(newArray);
        setAddBranchObj({
          branchName: '',
          branchAddress: '',
          bankContactPerson: {
            bankId: null,
            contactId: null,
            contactFirstName: '',
            contactLastName: '',
            contactPersonName: ''
          },
          contactPerson: '',
          branchStateId: '',
          stateName: '',
          branchCityId: '',
          cityName: '',
          branchCode: '',
          gstNumber: ''
        });
      }
    } else {
      setOpen1(true);
      setValidationMsg1('Branch already exists - Please try entering with another branch');
    }
  };

  const handleAddBranchEdit = async (e) => {
    if (addBranchObjEdit.branchName === '') {
      setOpen1(true);
      setValidationMsg1('Please select branch name');
      return;
    }
    if (addBranchObjEdit.branchAddress === '' || addBranchObjEdit.branchAddress === null) {
      setOpen1(true);
      setValidationMsg1('Please select branch address');
      return;
    }
    if (addBranchObjEdit.contactPerson === '' || addBranchObjEdit.contactPerson === null) {
      setOpen1(true);
      setValidationMsg1('Please add contact person');
      return;
    }

    if (addBranchObjEdit.stateName === '' || addBranchObjEdit.stateName === null) {
      setOpen1(true);
      setValidationMsg1('Please select state name');
      return;
    }
    if (addBranchObjEdit.cityName === '' || addBranchObjEdit.cityName === null) {
      setOpen1(true);
      setValidationMsg1('Please select city name');
      return;
    }
    if (addBranchObjEdit.branchCode === '' || addBranchObjEdit.branchCode === null) {
      setOpen1(true);
      setValidationMsg1('Please add login code');
      return;
    }

    const filteredData = branchList.filter(
      (branch, branchIndex) => branchIndexValue !== branchIndex
    );

    const filteredData2 = filteredData.filter(
      (branch) =>
        branch.branchName.toLowerCase().trim() === addBranchObjEdit.branchName.toLowerCase().trim()
    );

    if (filteredData2.length > 0) {
      setOpen1(true);
      setValidationMsg1('Branch already exists - Please try entering with another branch');
    } else {
      const newArray = branchList;
      const index = newArray.indexOf(itemBranchIndexValue);
      if (index === branchIndexValue) {
        newArray[index] = addBranchObjEdit;
      }
      branchEditDialogClose(e);
    }
  };

  const branchEditDialogOpen = (e, itemBranchIndex, branchIndex) => {
    setBranchEdit(true);
    setAddBranchObjEdit({
      branchName: itemBranchIndex ? itemBranchIndex.branchName : '',
      branchId: itemBranchIndex ? itemBranchIndex.branchId : '',
      branchAddress: itemBranchIndex ? itemBranchIndex.branchAddress : '',
      contactPerson: itemBranchIndex ? itemBranchIndex.contactPerson : '',
      bankContactPerson: {
        bankId: itemBranchIndex ? itemBranchIndex.bankContactPerson.bankId : '',
        contactId: itemBranchIndex ? itemBranchIndex.bankContactPerson.contactId : '',
        contactFirstName: itemBranchIndex ? itemBranchIndex.bankContactPerson.contactFirstName : '',
        contactLastName: itemBranchIndex ? itemBranchIndex.bankContactPerson.contactLastName : '',
        contactPersonName: itemBranchIndex
          ? itemBranchIndex.bankContactPerson.contactPersonName
          : ''
      },
      branchStateId: itemBranchIndex ? itemBranchIndex.branchStateId : '',
      stateName: itemBranchIndex ? itemBranchIndex.stateName : '',
      branchCityId: itemBranchIndex ? itemBranchIndex.branchCityId : '',
      cityName: itemBranchIndex ? itemBranchIndex.cityName : '',
      branchCode: itemBranchIndex ? itemBranchIndex.branchCode : '',
      gstNumber: itemBranchIndex ? itemBranchIndex.gstNumber || '' : ''
    });
    setBranchIndexValue(branchIndex);
    setitemBranchIndexValue(itemBranchIndex);
  };

  const branchEditDialogClose = (e) => {
    setBranchEdit(false);
  };

  const branchDeleteDialogOpen = (e, itemBranchIndex, branchIndex) => {
    setBranchItem(itemBranchIndex);
    setBranchIndex1(branchIndex);
    setDeleteConfirm(true);
  };

  const handleDeleteBranch = (e, branchItem, branchIndex1) => {
    if (branchItem.branchId === null) {
      const newArray = branchList;
      newArray.splice(branchIndex1, 1);
    } else {
      (async () => {
        const credentials = {
          agreementId: agreementId1,
          bankId: bankId1,
          branchId: branchItem.branchId,
          companyId: companyId1,
          userId: userId1
        };
        const DeleteBranch = await DeleteBranchInfo(credentials, LoginData?.jwt);
        if (DeleteBranch.status === 'success') {
          const newArray = branchList;
          newArray.splice(branchIndex1, 1);
        }
      })();
    }
    setDeleteConfirm(false);
  };

  const handleNextStep2 = async (e) => {
    const localJWTtoken = JSON.parse(localStorage.getItem('agreementId'));
    const authAgreementId = localJWTtoken.agreementId;
    const authCompanyId = localJWTtoken.companyId;
    const authUserId = localJWTtoken.userId;

    if (branchList.length === 0) {
      setOpen1(true);
      setValidationMsg1('Please Add bank branch');
      return;
    }

    const credentials2 = {
      aggrementId: authAgreementId,
      bankId: agreementBankId !== '' ? agreementBankId : null,
      branches: branchList.length > 0 ? branchList : null,
      companyId: authCompanyId,
      userId: authUserId
    };
    const SaveBranchInfoApi = await SaveBranchInfo(credentials2, LoginData?.jwt);
    if (SaveBranchInfoApi.status === 'success') {
      setActiveStep((activeStep) => activeStep + 1);

      const arData3 = [];
      SaveBranchInfoApi.data.branches.forEach((item, index) => {
        const branches3 = {
          branchName: item.branchName,
          branchId: item.branchId,
          branchAddress: item.branchAddress,
          bankContactPerson: {
            bankId: item.bankContactPerson.bankId,
            contactId: item.bankContactPerson.contactId,
            contactFirstName: item.bankContactPerson.contactFirstName,
            contactLastName: item.bankContactPerson.contactLastName,
            contactPersonName: item.bankContactPerson.contactPersonName
          },
          contactPerson: item.bankContactPerson.contactPersonName,
          branchStateId: item.stateEntity.stateId,
          stateName: item.stateEntity.stateName,
          branchCityId: item.cityEntity.cityId,
          cityName: item.cityEntity.cityName,
          branchCode: item.branchCode
        };
        arData3.push(branches3);
      });
      if (arData3.length > 0) {
        setBranchList(arData3);

        setReviewData({
          ...reviewData,
          branchDetails: arData3
        });

        localStorage.setItem(
          'reviewData',
          JSON.stringify({
            ...reviewData,
            branchDetails: arData3
          })
        );
      } else {
        dispatch(setApiError('Something went wrong'));
      }
    }
  };

  const getCityListApi = async (e, newValue) => {
    const CityListApiResponse = await CityList(
      {
        searchLiteral: '',
        stateId: newValue.stateId ? newValue.stateId : null
      },
      LoginData?.jwt
    );

    if (CityListApiResponse.action_status === 'success') {
      setCityListData(CityListApiResponse.data);
    } else {
      setCityListData([]);
    }
  };

  const getCityListApi2 = async (e, newValue) => {
    const CityListApiResponse = await CityList(
      {
        searchLiteral: '',

        stateId: newValue.stateId ? newValue.stateId : null
      },
      LoginData?.jwt
    );
    if (CityListApiResponse.action_status === 'success') {
      setCityListData2(CityListApiResponse.data);
    } else {
      setCityListData2([]);
    }
  };

  // Runs once
  useEffect(() => {
    const StepOneReponse = JSON.parse(localStorage.getItem('agreementId'));

    setAgreementId1(StepOneReponse?.agreementId);
    setBankId1(StepOneReponse?.bankId);
    setCompanyId1(StepOneReponse?.companyId);
    setUserId1(StepOneReponse?.userId);

    // State list API
    (async () => {
      const StateCredentials = { countryId: 101, searchLiteral: '' };
      const res = await StateList(StateCredentials, LoginData?.jwt);
      setStateListData(res.action_status === 'success' ? res.data : []);
    })();

    // Review data
    const authReviewData = JSON.parse(localStorage.getItem('reviewData'));
    // console.log('authReviewData222', authReviewData);
    if (authReviewData) {
      setAgreementBankId(StepOneReponse?.agreementBankId);

      if (authReviewData.branchDetails?.length) {
        const arData2 = authReviewData.branchDetails.map((item) => ({
          branchName: item.branchName,
          branchId: item.branchId,
          branchAddress: item.branchAddress,
          bankContactPerson: {
            bankId: item.bankContactPerson?.bankId ?? null,
            contactId: item.bankContactPerson?.contactId ?? null,
            contactFirstName: item.bankContactPerson?.contactFirstName ?? '',
            contactLastName: item.bankContactPerson?.contactLastName ?? '',
            contactPersonName: item.bankContactPerson?.contactPersonName ?? ''
          },
          contactPerson: item.contactPerson,
          branchStateId: item.branchStateId,
          stateName: item.stateName,
          branchCityId: item.branchCityId,
          cityName: item.cityName,
          branchCode: item.branchCode
        }));

        setBranchList(arData2);
      }

      // Bank branch API
      (async () => {
        // const res = await AgreementBankBranchList(authReviewData.agreementBankId, LoginData?.jwt);
        const res = [];
        if (res.status === 'success') {
          const arData1 = res.data.branches.map((item) => ({
            branchName: item.branchName,
            branchId: item.branchId,
            branchAddress: item.branchAddress,
            contactPerson: item.contactPersonName,
            bankContactPerson: {
              bankId: item.contactPerson?.bankId ?? null,
              contactId: item.contactPerson?.contactId ?? null,
              contactFirstName: item.contactPerson?.contactFirstName ?? '',
              contactLastName: item.contactPerson?.contactLastName ?? '',
              contactPersonName: item.contactPerson?.contactPersonName ?? ''
            },
            branchStateId: item.stateId,
            stateName: item.stateEntity.stateName,
            branchCityId: item.cityId,
            cityName: item.cityEntity.cityName,
            branchCode: item.branchCode
          }));
          setBranchList(arData1);
        }
      })();
    }
  }, []); // 👈 runs once only

  useEffect(() => {
    if (location.pathname === '/agreement/edit' && AgreementEdit?.branches?.length) {
      const arData = AgreementEdit.branches.map((item) => ({
        branchName: item.branchName,
        branchId: item.branchId,
        branchAddress: item.branchAddress,
        contactPerson: item.contactPersonName,
        bankContactPerson: {
          bankId: item.contactPerson?.bankId ?? null,
          contactId: item.contactPerson?.contactId ?? null,
          contactFirstName: item.contactPerson?.contactFirstName ?? '',
          contactLastName: item.contactPerson?.contactLastName ?? '',
          contactPersonName: item.contactPerson?.contactPersonName ?? ''
        },
        branchStateId: item.stateId,
        stateName: item.stateEntity.stateName,
        branchCityId: item.cityId,
        cityName: item.cityEntity.cityName,
        branchCode: item.branchCode
      }));

      setBranchList(arData);
    }
  }, [AgreementEdit]);

  return (
    <>
      <Box className="viewLeadCard" mb={3}>
        <Grid container spacing={3} mb={3}>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Branch Name
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Branch Name"
                value={addBranchObj.branchName}
                onChange={(e) => {
                  setAddBranchObj({ ...addBranchObj, branchName: e.target.value, branchId: null });
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Branch Address
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Bank Address"
                value={addBranchObj.branchAddress}
                onChange={(e) => {
                  setAddBranchObj({ ...addBranchObj, branchAddress: e.target.value });
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Contact Person
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Contact Person"
                value={addBranchObj.contactPerson}
                onChange={(e) => {
                  setAddBranchObj({
                    ...addBranchObj,
                    contactPerson: e.target.value,
                    bankContactPerson: {
                      ...addBranchObj.bankContactPerson,
                      bankId: agreementBankId,
                      contactId: null,
                      contactFirstName: '',
                      contactLastName: '',
                      contactPersonName: e.target.value
                    }
                  });
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                State
              </Typography>
              <Autocomplete
                disablePortal
                id="combo-box-demo1"
                options={stateListData}
                size="small"
                value={addBranchObj.stateName}
                onChange={(e, newValue) => {
                  setAddBranchObj({
                    ...addBranchObj,
                    branchCityId: '',
                    cityName: '',
                    branchStateId: newValue.stateId,
                    stateName: newValue.stateName
                  });
                  getCityListApi(e, newValue);
                }}
                getOptionLabel={(option) =>
                  option.stateName ? option.stateName : addBranchObj.stateName
                }
                renderOption={(props, option) => <li {...props}>{option.stateName}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select State" />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                City
              </Typography>
              <Autocomplete
                disablePortal
                id="combo-box-demo2"
                options={cityListData}
                size="small"
                value={addBranchObj.cityName}
                onChange={(e, newValue) => {
                  setAddBranchObj({
                    ...addBranchObj,
                    branchCityId: newValue.cityId,
                    cityName: newValue.cityName
                  });
                }}
                getOptionLabel={(option) =>
                  option.cityName ? option.cityName : addBranchObj.cityName
                }
                renderOption={(props, option) => <li {...props}>{option.cityName}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Branch Code
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                placeholder="Type Branch Code"
                value={addBranchObj.branchCode}
                onChange={(e) => {
                  setAddBranchObj({ ...addBranchObj, branchCode: e.target.value });
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                GST Number{' '}
                <span style={{ color: '#888', fontWeight: 400, fontSize: '11px' }}>(Optional)</span>
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput',
                  maxLength: 15
                }}
                placeholder="e.g. 27ABCDE1234F1Z5"
                value={addBranchObj.gstNumber}
                onChange={(e) => {
                  setAddBranchObj({ ...addBranchObj, gstNumber: e.target.value.toUpperCase() });
                }}
              />
            </Box>
          </Grid>
        </Grid>
        <Box textAlign="right">
          <Button
            className="mainBtn otherBtn"
            variant="contained"
            onClick={(e) => handleAddBranch(e)}
          >
            Add Branch
          </Button>
        </Box>
      </Box>
      <Box className="greenBorder tableBox" mt={3}>
        <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Branch Name</StyledTableCell>
                <StyledTableCell align="">Branch Address</StyledTableCell>
                <StyledTableCell align="">Contact Person</StyledTableCell>
                <StyledTableCell align="" width={80}>
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {branchList && branchList.length > 0
                ? branchList.map((item, index) => {
                    console.log(item);
                    return (
                      <StyledTableRow>
                        <StyledTableCell align="">{item.branchName}</StyledTableCell>
                        <StyledTableCell align="">{item.branchAddress}</StyledTableCell>
                        <StyledTableCell align="">{item.contactPerson}</StyledTableCell>
                        <StyledTableCell align="">
                          <UserMoreMenu
                            parent="add-branch-agreement"
                            setBranchEdit={setBranchEdit}
                            setDeleteConfirm={setDeleteConfirm}
                            itemBranchIndex={item}
                            branchIndex={index}
                            branchEditDialogOpen={branchEditDialogOpen}
                            branchDeleteDialogOpen={branchDeleteDialogOpen}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })
                : ''}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          fullWidth
          className="PopupBox"
          open={branchEdit}
          onClose={(e) => branchEditDialogClose(e)}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Edit Details</Typography>
            <IconButton onClick={(e) => branchEditDialogClose(e)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Branch Name
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Branch Name"
                    value={addBranchObjEdit.branchName}
                    onChange={(e) => {
                      setAddBranchObjEdit({ ...addBranchObjEdit, branchName: e.target.value });
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Branch Address
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Bank Address"
                    value={addBranchObjEdit.branchAddress}
                    onChange={(e) => {
                      setAddBranchObjEdit({ ...addBranchObjEdit, branchAddress: e.target.value });
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Contact Person
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Contact Person"
                    value={addBranchObjEdit.contactPerson}
                    onChange={(e) => {
                      setAddBranchObjEdit({
                        ...addBranchObjEdit,
                        contactPerson: e.target.value,
                        bankContactPerson: {
                          ...addBranchObjEdit.bankContactPerson,
                          bankId: agreementBankId,
                          contactFirstName: '',
                          contactLastName: '',
                          contactPersonName: e.target.value
                        }
                      });
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    State
                  </Typography>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo3"
                    options={stateListData}
                    size="small"
                    value={addBranchObjEdit.stateName}
                    onChange={(e, newValue) => {
                      setAddBranchObjEdit({
                        ...addBranchObjEdit,
                        branchCityId: '',
                        cityName: '',
                        branchStateId: newValue.stateId,
                        stateName: newValue.stateName
                      });
                      getCityListApi2(e, newValue);
                    }}
                    getOptionLabel={(option) =>
                      option.stateName ? option.stateName : addBranchObjEdit.stateName
                    }
                    renderOption={(props, option) => <li {...props}>{option.stateName}</li>}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth placeholder="Select State" />
                    )}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    City
                  </Typography>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo4"
                    options={cityListData2}
                    size="small"
                    value={addBranchObjEdit.cityName}
                    onChange={(e, newValue) => {
                      setAddBranchObjEdit({
                        ...addBranchObjEdit,
                        branchCityId: newValue.cityId,
                        cityName: newValue.cityName
                      });
                    }}
                    getOptionLabel={(option) =>
                      option.cityName ? option.cityName : addBranchObjEdit.cityName
                    }
                    renderOption={(props, option) => <li {...props}>{option.cityName}</li>}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth placeholder="Select City" />
                    )}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Branch Code
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput'
                    }}
                    placeholder="Type Branch Code"
                    value={addBranchObjEdit.branchCode}
                    onChange={(e) => {
                      setAddBranchObjEdit({ ...addBranchObjEdit, branchCode: e.target.value });
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    GST Number{' '}
                    <span style={{ color: '#888', fontWeight: 400, fontSize: '11px' }}>
                      (Optional)
                    </span>
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'textInput',
                      maxLength: 15
                    }}
                    placeholder="e.g. 27ABCDE1234F1Z5"
                    value={addBranchObjEdit.gstNumber || ''}
                    onChange={(e) => {
                      setAddBranchObjEdit({
                        ...addBranchObjEdit,
                        gstNumber: e.target.value.toUpperCase()
                      });
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                handleAddBranchEdit(e);
              }}
              variant="contained"
              className="mainBtn"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth
          className="PopupBox"
          open={deleteConfirm}
          onClose={(e) => setDeleteConfirm(false)}
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">Delete Confirmation</Typography>
            <IconButton onClick={(e) => setDeleteConfirm(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography>Are you sure you want to delete?</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                handleDeleteBranch(e, branchItem, branchIndex1);
              }}
              variant="contained"
              className="mainBtn deleteBtn"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={handlePrev}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          onClick={(e) => handleNextStep2(e)}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>
      <Dialog
        open={open1}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{validationMsg1}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose1}>Retry</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
